import React from "react";
import parentClasses from "../Buttons.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as btnConfig from "../btnsSetup";

const TagA = ({
  className = "",
  href = "#",
  type = "button",
  rounded = null,
  disable = null,
  onClick = () => {},
  text = null,
  target = "",
  faIcon = null,
  btnType = null,
  size = null,
  alt = null,
  title = null,
  style = {},
}) => {
  /**
   * Setting button content
   */
  // inner _text
  const _btnRoundedClass = rounded ? parentClasses.Rounded : "";
  const _text = text ? (
    <span className={parentClasses.Text}>{text}</span>
  ) : null;
  const _faIcon = faIcon ? <FontAwesomeIcon icon={faIcon} /> : null;

  /**
   * Setting button parentClasses
   */
  // Check the button type (style of the button)
  let btnTypeClass = btnConfig.getBtnTypeClass(btnType);

  // Check the button size
  let btnSizeClass = btnConfig.getBtnSize(size);

  const _alt = alt ? alt : title ? title : text;

  /**
   * Returing button
   */
  return (
    <a
      style={style}
      disabled={disable}
      className={`${btnTypeClass} ${btnSizeClass} ${_btnRoundedClass}  ${className}`}
      type={type}
      target={target}
      href={href}
      onClick={onClick}
      title={title ? title : null}
      alt={_alt}
    >
      {_faIcon}
      {_text}
    </a>
  );
};

export default TagA;
